<template>
    <div class="ui buttons big">
        <button
            class="button no"
            @click="toggle('no')"
            :class="[!activeStatus ? 'active' : '']"
        >No</button>
        <button
            class="button yes"
            @click="toggle('yes')"
            :class="[activeStatus ? 'active' : '']"
        >Yes</button>
        </div>
  </template>
  
  <script>

  
  export default {
    name: 'YesNoToggleButton',
    props: {
      id: {
        type: [String, Number],
        required: false
      },
      defaultValue: {
        type: String,
        required: false,
        default: 'no'
      }
    },
    data () {
      return {
        activeStatus: false,
        value: 'yes'
      };
    },
    methods: {
      toggle(value) {
        this.activeStatus = !this.activeStatus;
        this.value = value;
        this.$emit('input', this.value, this.id);
      },
    },
    watch: {
     defaultValue(newDefaultValue,oldDefaultValue){
        if(newDefaultValue == 'no')
            this.activeStatus = false;
        else if(newDefaultValue == 'yes')
            this.activeStatus = true;
        this.value = newDefaultValue;
     },
    }
  }
  </script>
    <style lang="scss" scoped>
    .buttons{
        //position: relative;
        display: block;
        margin: 0 auto;
        width: 85%;
        .button{
            background: #FFFFFF;
            //position: absolute;
            //top: 0;
            //left: 0;
            border: none;
            width: 35px;
            height: 21px;
            background: #FFFFFF 0% 0% no-repeat padding-box;
            box-shadow: 0px 3px 6px #00000029;
            border-radius: 12px;
            opacity: 1;
            font-size: 12px;
            &.no{
                color: #A2A4A7;
                top: 697px;
                left: 573px;
            }
            &.yes{
                color: #1381A2;
                top: 697px;
                left: 495px;
            }
            &.active{
                background: #1381A2 !important;
                color: #FFFFFF !important;
            }
        }
    }
    </style>
  